<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 15 15" fill="none">
        <path d="M1.5 1.5L13.5 13.5M1.5 13.5L13.5 1.5" stroke="white"/>
    </svg>
</template>

<script>
export default {
    name: "AtomIcClose",
    props: {
        width: {
            type: Number,
            default: 40
        },
        height: {
            type: Number,
            default: 40
        }
    },

}
</script>

